export default {
  company: "INDOMASCOT",
  title: "Custom Mascot Costume Specialist",
  titleHero: "Mascot Costume Specialist",
  home: "Home",
  search: "Search",
  welcome: "Welcome",
  specialist: "Specialist",
  howToOrderMascotCostume: "How to Order Mascot Costume",
  howToOrderCostumDoll: "How to Order Custom Doll",
  aboutUs: "About Us",
  termsAndConditions: "Terms & Conditions",
  portfolio: "Portfolio",
  customDoll: "Custom Doll",
  mascotCostume: "Mascot Costume",
  blog: "Blog",
  generalTermsAndConditions: "General Terms & Conditions",
  designCanBeSentVia: "Mascot designs can be submitted via",
  or: "or",
  paymentTransferredByAccount:
    "Payments are transferred to our bank account with the following details:",
  bankName: "Bank Name",
  accountHolder: "Account Holder Name",
  accountNo: "Account No.",
  contact: "contact",
  workshop: "workshop",
  howToOrder: "how to order",
  forFastResponse: "for fast response",
  aboutEstimatesEtc: "about estimates, etc, ",
  pleaseContactUs: "please contact us",
  weProduce:
    "More than hundreds of MSMEs, startups, communities and government institutions have trusted us to produce custom mascot clown costumes with their own designs for events, socialization, promotions and branding purposes.",
  andManyMore: "and many more",
  mascotCostumeSubtitle:
    "This mascot costume is all-size, which means that it is proportionally worn by adults whose height is generally 170-190cm.",
  showMore: "show more",
  potentialCustomer: "potential customer",
  aboutUsParagraph: {
    p1: "We want to work with you to support the marketing of your company's products and services 🏆",
    p2: "The solution we offer is to present high-quality artwork compared to similar competitors in the form of a mascot costume to support the success of your company's marketing targets.",
    p3: "Armed with more than 10 years of experience & relationships, we believe we can help your company's marketing activities such as enliven events so that they get the attention of your potential customers.",
    p4: "When you have reached the condition that you have received attention, it will be much easier for you to convey the information you want to convey to your potential customers.",
    p5: "Please visit our workshop location in Bandung to see firsthand how from start to finish the process of making the mascot costume takes place.",
    p6: "Don't forget to mention that we have been able to serve the community until now, no doubt because we are always assisted by our high quality supplier relations 🙏 ",
  },
  contactUs: "Contact Us",
  ifThereIsSomethingElse: "If you have any questions, please contact us via",
  ourPostalAddress: "Our postal address:",
  generalTerms: {
    li3: "The new manufacturing process will start 1 day after the DP & mascot design is received.",
    li4: {
      shipping: "Shipping",
      pickInWorkshop: "Self Pick UP",
      youCanPickInWorkshop:
        "Your mascot costume are always can be picked up in working hours at our workshop at:",
      byCourier: "Shipped Using a Shipping/Expediting Agent",
      air: "air",
      sea: "sea",
      land: "land",
      jabodetabek: "Jabodetabek",
      sumatera: "Sumatera, Kalimantan, Sulawesi & Bali",
      borneo: "Kalimantan",
      sulawesi: "Sulawesi",
      papua: "Papua",
      lainnya: "Lainnya",
      orByCustomDeal:
        "or use the delivery service selected according to mutual agreement.",
    },
    li5: "Issues related to the copyright of the mascot design, are fully borne by the client.",
    li6: "All consequences of changing the invoice price at the client's request, are fully borne by the client.",
    li7: "Changes may occur at any time without notice.",
    li8: "By ordering here, you are agreeing to the terms & conditions on this page.",
  },
  mascotCostumeTerms: {
    title: "MASCOT COSTUME",
    li1: "DP (Down Payment) for each 1 unit is Rp. 1,500,000,-.",
    li2: "Generally the manufacturing process takes 10-14 working days (Sundays off).",
    li3: "Mascot costumes that have been completed but the client does not complete the payment within 30 days, then the condition of the mascot costume is no longer our responsibility.",
    li4: "INDOMASCOT has the right to display photos & videos of the mascot costumes made for portfolio purposes, unless there is a special request from the client.",
  },
  customDollTerms: {
    title: "CUSTOM DOLL (CUSTOM LITTLE DOLL)",
  },
  lastEdited: "Last edited: ",
  whatIsMascotCostume: "What is a mascot costume?",
  accordingToWikipedia:
    "According to WikiPedia, a mascot clown costume is a costume made by a company to make their mascot/company logo real to the public. These costumes are often used for brand socialization, company promotions, exhibitions, or increasing a team's brand awareness in a sporting event. Because it will be used by humans, the design must adjust the proportions of the human body.",
  whatIsTheDifferent: "How is it different from a clown suit?",
  itsJustTheSame:
    "Just the same. It's just the name sometimes nowadays people prefer to call it a clown suit or a clown costume. This clown suit is all-size, which means that it is proportionally worn by adults whose height is generally 170-190cm. For the design, it can also be taken from the mascot doll which is first adjusted to the proportions of the human body.",
  yourSuccess: "Your Marketing and Outreach Success Is Our Mission",
  brandMarketingIsImportant:
    "Marketing a brand or product is something that is challenging for a company. In fact, conveying the message of socialization is sometimes still difficult to achieve for an agency that is widely known by the public. We are here to help with producing mascot costumes to help your event marketing success!",
  qualityMaterial: "The Quality of The Material",
  velboa: "velboa",
  drill: "drill",
  lotto: "lotto",
  furing: "furing",
  toSatisfy:
    "To satisfy our clients, we only use the {firstGrade} quality fabrics in the market. This fabric is not hot and soft. Starting from the type of {velboa} (doll), {drill} to {lotto} in various colors to get results that are similar to the original design. And also we have a special layer called {furing} to asborbe sweat optimally.",
  fast: "Fast Results",
  inOurProcess:
    "In our process up to now, we have several times found our clients are in a hurry because the costumes will be worn soon, for example within 2 weeks after the down payment. Therefore, we optimize the production speed to only take 10 days (Sundays off).",
  freeBonusHeadFanAndMask: "Free Bonus Head Fan",
  performerIsSweating:
    "The performer must be sweating very easily due to the warm temperature inside the mask. This indirectly results in performers experiencing fatigue quickly. Therefore, we provide a bonus exhaust head fan to help circulate the mask more smoothly (free).",
  howToOrderMascotCostumeSteps: {
    step0: "",
    step1: "Send The Mascot Design",
    step2: "We Send The Estimates",
    step3: "DP (Down Payment) & Payment Confirmation",
    step4: {
      0: "We Send The Final Photos",
      1: "Front View Final Photo Progress",
      2: "Side View Final Photo Progress",
      3: "Rear View Final Photo Progress",
    },
    step5: "Pay The Rest & Payment Confirmation",
    step6: "We Ship Your Mascot Costume",
  },
  description: {
    index:
      "INDOMASCOT serves the manufacture of large (custom) mascot dolls for branding your product or agency with your own design.",
  },
  keywords: {
    index: "clown costume, mascot, mascot costumes, mascot costume",
  },
  pageTitle: {
    mascotCostume: "Portfolio",
    toc: "Terms of Conditions",
    aboutUs: "About Us",
    customDoll: "Custom Doll Specialist",
    blog: "Latest Articles",
  },
  pageDescription: {
    index:
      "INDOMASCOT serves the manufacture of mascot clown costumes for branding your product or agency with your own design. (WhatsApp 0822-2155-6633)",
    mascotCostume:
      "All mascot clown costumes (custom) with clients' own designs that we have worked on are here.",
    toc: "The terms and conditions for ordering a mascot clown costume with us are here.",
    aboutUs:
      "We want you to build your marketing success together with our mascot clown costumes.",
    blog: "INDOMASCOT always presents news about mascot clown costumes that are useful for you.",
  },
  mascot: "{mascotName} Mascot",
  author: "Author: ",
  publishedDate: "Published Date: ",
  searchResultsFor: "Search Results For ",
  whatsAppNo: "0822-2155-6633",
  topbar: {
    message: {
      closeOrder: "CLOSE ORDER",
      full: "because we already full until {date}",
      openAgain: "・ till May, 8 2022",
      happyNewYear2022: "Happy New Year 2022",
      happyImlek2022: "Happy Chinese New Year 2022",
    },
  },
  fitting: "fitting",
  show100more: "show 100+ more",
  uploadDesign: "Upload Design",
  backToBlog: "Back to Blog page",
  showAll: "Show All",
  lastUpdated: "Last updated: ",
  dollMascotCostume: "{0} Mascot Costume",
  fullSizePhoto: "Full Size {0} Photo",
  design: "Design",
  proportional: "Proportioned",
  screenshot: "Screenshot",
  fittingInstruction: {
    upload: {
      useButton: "Please use",
      below: "button below.",
      beside: "button beside.",
    },
    proportional: "Prepare the mascot design that already",
    resizeDragRotate: {
      useHandle: "Resize, Drag & Rotate",
      ifNeeded: "after upload if needed.",
    },
    removeBg: "Use background removal like",
    png: "File must be in ",
    screenshot: "and send it to us.",
  },
  apps: "Apps",
  install: "Install",
  iosInstallation: {
    share: "Tap Share Icon",
    addToHomeScreen: "Tap Add To Home Screen",
    add: "Tap Add",
    voila: "Voila, INDOMASCOT app installed successfully",
  },
  onlyOn: {
    apple: "only on iOS Safari",
    android: "only on Android Chrome",
    chrome: "only on Chrome browser",
  },
  allArticles: "All Articles",
  underConstruction: "Under Construction",
  designFitting: "design fitting",
  pageNotFound: "Sorry, Page Not Found.",
  allHashtags: "All Hashtags",
  designBy: "designed by",
  designOwnedBy: "The design above is owned by",
  featuredClients: "Featured Clients",
  newest: "Latest",
  orSee: "or see",
  seeAtGoogleMaps: "see at Google Maps",
  productionTeam: "Production Team",
};
